import MultiColumnModule from "@/components/site-builder/MultiColumnModule";
import type { SpeakersModuleType } from "./types";
import SpeakerVariant1 from "./SpeakerVariant1";

export interface SpeakersModuleProps {
  module: SpeakersModuleType;
}

export default function SpeakersModule(props: SpeakersModuleProps) {
  const { module } = props;
  const {
    body: { speakers, speakerImage, showCompanyLogo, disableSpeakerCardUrl },
  } = module;

  return (
    <MultiColumnModule
      module={module}
      blocks={speakers}
      renderBlock={(speaker) => (
        <SpeakerVariant1
          speaker={speaker}
          imageSettings={speakerImage}
          showCompanyLogo={showCompanyLogo}
          disableSpeakerCardUrl={disableSpeakerCardUrl}
        />
      )}
    />
  );
}
